(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-code-previewer", [], factory);
	else if(typeof exports === 'object')
		exports["react-code-previewer"] = factory();
	else
		root["react-code-previewer"] = factory();
})(window, function() {
return 